import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { findRedirect } from "./redirects";

/**
 * RedirectHandler component that checks if current URL matches an old URL
 * and redirects to the new URL if found.
 *
 * This component should be placed inside the BrowserRouter but rendered
 * on every route to catch legacy URLs.
 */
const RedirectHandler = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectTo = findRedirect(location.pathname);

    if (redirectTo) {
      // Use replace to avoid adding to history stack
      // This creates a proper redirect experience
      navigate(redirectTo, { replace: true });
    }
  }, [location.pathname, navigate]);

  return children;
};

export default RedirectHandler;
